import { useSyncExternalStore } from 'react';

import { abonnerLangue, langueMobile, type LangueMobile } from './langue';

/**
 * La langue courante, pour la coque : elle sert de clé au contenu, qui se remonte
 * à neuf au changement de langue (voir `langue.ts`). Les écrans n'en ont pas
 * besoin : ils appellent `t()`.
 */
export function useLangueMobile(): LangueMobile {
    return useSyncExternalStore(abonnerLangue, langueMobile, langueMobile);
}
